module.exports = __webpack_public_path__ + "img/circle-phone-flip.7ad5e3b1.svg";